module["exports"] = ["Pan", "Pani"];